<template>
  <div>
    <title-edit header="Mini TCDC" />
    <line-hr />
    <div class="row">
      <v-col cols="12" sm="4" xs="12" class="label">
        &nbsp;
      </v-col>
      <v-col cols="12" sm="6" xs="12">
        <v-app class="switch-app">
          <v-switch label="Default Publish" color="tcdc_color" v-model="form.is_default_display" />
        </v-app>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="4" xs="12" class="label">
        <label>Branch* :</label>
      </v-col>
      <v-col cols="6" sm="6" xs="12">
        <select-option :items="optionBranch" :model="form.branch_id" @update="updateBranch" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="4" xs="12" class="label">
        <label>Mini TCDC name TH* :</label>
      </v-col>
      <v-col cols="6" sm="6" xs="12">
        <input-text-field :model="form.branch_name_th" @update="updateBranchNameTH" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="4" xs="12" class="label">
        <label>Mini TCDC name EN* :</label>
      </v-col>
      <v-col cols="6" sm="6" xs="12">
        <input-text-field :model="form.branch_name_en" @update="updateBranchNameEN" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="4" xs="12" class="label">
        <label>Zone* :</label>
      </v-col>
      <v-col cols="12" sm="6" xs="12">
        <select-option :items="optionZone" :model="form.zone" @update="updateZone" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="4" xs="12" class="label">
        <label>Type* :</label>
      </v-col>
      <v-col cols="12" sm="6" xs="12">
        <select-option :items="optionBranchType" :model="form.type_id" @update="updateType" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="4" xs="12" class="label">
        <label>Cover image desktop name :</label>
      </v-col>
      <v-col cols="12" sm="6" xs="12">
        <input-text-field
          :model="form.image_cover_desktop_name"
          @update="updateImageCoverDesktopName"
        />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="4" xs="12" class="label">
        <label>Cover image desktop :</label>
        <div style="color: #2E8037; font-size: 12px">
          *รองรับ JPEG ,PNG ขนาดไฟล์ไม่เกิน 500KB
        </div>
      </v-col>
      <v-col cols="12" sm="6" xs="12">
        <input-image-upload
          id="input1"
          height="200px"
          @update="updateImageCoverDesktopPath"
          :name="form.image_cover_desktop_name"
          :model="form.image_cover_desktop_path_show"
          :error-size="'500'"
        />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="4" xs="12" class="label">
        <label>Cover image mobile name :</label>
      </v-col>
      <v-col cols="12" sm="6" xs="12">
        <input-text-field
          :model="form.image_cover_mobile_name"
          @update="updateImageCoverMobileName"
        />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="4" xs="12" class="label">
        <label>Cover image mobile :</label>
        <div style="color: #2E8037; font-size: 12px">
          *รองรับ JPEG ,PNG ขนาดไฟล์ไม่เกิน 500KB
        </div>
      </v-col>
      <v-col cols="12" sm="6" xs="12">
        <input-image-upload
          id="input2"
          height="140px"
          width="140px"
          menu="mini_branch"
          :model="form.image_cover_mobile_path_show"
          :name="form.image_cover_mobile_name"
          :error-size="'500'"
          @update="updateImageCoverMobilePath"
          col="col-6"
        />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="4"   class="label">
        <label>Order : </label>
      </v-col>
      <v-col cols="12" sm="6"   xs="12">
        <input-text-field @update="updateOrder" :model="form.orders" />
      </v-col>
    </div>
    <line-hr />
    <command-button @delete-info="deleteMiniTCDC" @save-info="saveMiniTCDC" @save-close="saveClose"></command-button>
    <!--    <pre>{{form}}</pre>-->
  </div>
</template>

<script>
import SelectOption from "../../../components/Input/selectOption";
import InputTextField from "../../../components/Input/InputTextField";
import DeleteButton from "../../../components/Button/DeleteButton";
import PreviewButton from "../../../components/Button/PreviewButton";
import SaveButton from "../../../components/Button/SaveButton";
import TitleEdit from "../../../components/TitleHeader/TitleEdit";
import LineHr from "../../../components/Icon/line-hr";
import InputImageUpload from "../../../components/Input/InputImageUpload";
import SwitchSelect from "../../../components/Input/StyleUtility";
import { mapState } from "vuex";
import {
  permissionMiniTCDC, role,
} from "../../../util/Permission";
import Swal from "sweetalert";
import CommandButton from "../../../components/Layout/CommandButton";
export default {
  name: "MiniTCDCEdit",
  components: {
    CommandButton,
    SwitchSelect,
    InputImageUpload,
    LineHr,
    TitleEdit,
    SaveButton,
    PreviewButton,
    DeleteButton,
    InputTextField,
    SelectOption
  },
  computed: {
    permissionMiniTCDC,
    ...mapState({
      form: state => {
        return state.TCDCMini.form;
      }
    })
  },
  data() {
    return {
      permission : null,
      optionBranch: [],
      optionBranchType: [],
      optionZone: [
        { value: "", text: "Select" },
        { value: 1, text: "ภาคเหนือ" },
        { value: 2, text: "ภาคตะวันออกเฉียงเหนือ" },
        { value: 3, text: "ภาคตะวันตก" },
        { value: 4, text: "ภาคกลาง" },
        { value: 5, text: "ภาคตะวันออก" },
        { value: 6, text: "ภาคใต้" }
      ]
    };
  },
  created() {
    this.permission = role;
    this.getBranchData();
    this.getBranchType();
  },
  methods: {
    getBranchData() {
      this.$store
        .dispatch("Branch/getBranchAll")
        .then(res => {
          this.optionBranch = [
            { text: "Select", value: "" },
            ...res.filter(val => val.branch_id === 5)
                    .map(type => ({
              value: type.branch_id,
              text: type.branch_name_th + " (" + type.branch_name_en + ")"
            }))
          ];
        })
        .catch(() => {
          Swal('','Cannot get branch data','error');
        });
    },
    getBranchType() {
      this.$store
        .dispatch("MiniType/getAllMiniType")
        .then(res => {
          this.optionBranchType = [
            { text: "Select", value: "" },
            ...res.map(type => ({
              value: type.type_id,
              text: type.type_name
            }))
          ];
        })
        .catch(() => {
          Swal('','Cannot get branch type data','error');
        });
    },
    validateSave() {
      if (!this.form.branch_id) {
        Swal('','Please select Branch !','error');
        return false;
      } else if (!this.form.branch_name_th) {
        Swal('','Please insert Branch Name TH !','error');
        return false;
      } else if (!this.form.branch_name_en) {
        Swal('','Please insert Branch Name EN !','error');
        return false;
      } else if (!this.form.zone) {
        Swal('','Please select Zone !','error');
        return false;
      } else if (!this.form.type_id) {
        Swal('','Please select Type !','error');
        return false;
      // } else if (!this.form.image_cover_desktop_path) {
      //   Swal('','Please select Cover image desktop !','error');
      //   return false;
      // } else if (!this.form.image_cover_mobile_path) {
      //   Swal('','Please select Cover image mobile !','error');
      //   return false;
      } else {
        return true;
      }
    },
    saveClose() {
      if (this.validateSave()) {
        this.$store
                .dispatch("TCDCMini/saveTCDCMini", {
                  id: this.save_id ? this.save_id : this.form.id,
                  data: this.form
                })
                .then(res => {
                  Swal(res.response_msg);
                  if (res.response_code == 200) {
                    this.goToMiniTCDCTable();
                  }
                })
                .catch(() => {
                  Swal('','Cannot save mini tcdc','error');
                });
      }
    },
    saveMiniTCDC() {
      if (this.validateSave()) {
        this.$store
          .dispatch("TCDCMini/saveTCDCMini", {
            id: this.save_id ? this.save_id : this.form.id,
            data: this.form
          })
          .then(res => {
            this.save_id = res.result.id;
            Swal(res.response_msg);
          })
          .catch(() => {
            Swal('','Cannot save mini tcdc','error');
          });
      }
    },
    goToMiniTCDCTable() {
      this.$router.push("/branch/mini-TCDC");
    },
    deleteMiniTCDC() {
      this.$store
        .dispatch("TCDCMini/deleteTCDCMini", this.form.id)
        .then(res => {
          Swal(res.response_msg);
          if (res.response_code == 200) {
            this.goToMiniTCDCTable();
          }
        })
        .catch(() => {
          Swal('','Cannot delete venue hire','error');
        });
    },
    updateBranch(val) {
      this.form.branch_id = val;
    },
    updateBranchNameTH(val) {
      this.form.branch_name_th = val;
    },
    updateBranchNameEN(val) {
      this.form.branch_name_en = val;
    },
    updateDetailTH(val) {
      this.form.detail_th = val;
    },
    updateDetailEN(val) {
      this.form.detail_en = val;
    },
    updateImageCoverDesktopPath(val) {
      this.form.image_cover_desktop_path = val.imagePath;
      this.form.image_cover_desktop_path_show = val.fullImagePath;
      this.form.image_cover_desktop_name = val.file_name;
    },
    updateImageCoverDesktopName(val) {
      this.form.image_cover_desktop_name = val;
    },
    updateImageCoverMobilePath(val) {
      this.form.image_cover_mobile_path = val.imagePath;
      this.form.image_cover_mobile_path_show = val.fullImagePath;
      this.form.image_cover_mobile_name = val.file_name;
    },
    updateImageCoverMobileName(val) {
      this.form.image_cover_mobile_name = val;
    },
    updateZone(val) {
      this.form.zone = val;
    },
    updateType(val) {
      this.form.type_id = val;
    },
    updateOrder(val) {
      this.form.orders = val;
    },
  }
};
</script>

<style scoped></style>
